import { useState, useEffect, useRef, useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Dropdown, Icon } from 'semantic-ui-react';
import HeaderContext from '../context/HeaderContext';
import Loading from '../components/Loading';
import { getAPI } from '../libs/fetchAPI';
import { ReactComponent as Logo } from '../logo.svg';

const HeaderContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0 10px;
	height: 55px;
	width: 100%;
	/*background : rgb(59, 146, 222);*/
	background : #232f3e;
`;

const Title = styled.div`
	display: flex;
	justify-content: center;
	flex-direction : column;
	color: #fff;
	font-weight: 700;
	font-size: 16px;
`;

const Right = styled.div`
	display: flex;
	justify-content: center;
	padding-top: 8px;
`;

const TopLink = styled.span`
	margin: 0 5px 0 5px;
	color: #fff;
	cursor: pointer;

	:hover {
		color: #e0e0e0;
	}
`;

const SiteNameLink = styled(Link)`
	color: #fff;

	:hover {
		color: #fff;
	}
`;

const IconDownArrow = styled(Icon)`
	cursor: pointer;

	:hover {
		color: #e0e0e0;
	}
`;

const CustomLink = styled(Link)`
	display: block;
	width: 100%;
	color: #000;
	cursor: pointer;

	:hover {
		color: gray;
	}
`;

const LogoutLink = styled.a`
	display: block;
	width: 100%;
	color: #000;
	cursor: pointer;

	:hover {
		color: gray;
	}
`;

const MenuUL = styled.ul`
	position: fixed;
	top: 55;
	right: 0;
	margin: -3px 35px 0 0;
	padding: 5px 25px 5px 25px;
	background: #f8f8f8;
	border: 1px solid rgba(34,36,38,.1);
	border-radius: 5px;
	box-shadow: 0 0 4px #b8b8b8;
	z-index: 20;
	list-style-type: none;
`;

const MenuLI = styled.li`
	padding: 8px 0;
	border-bottom: 1px solid rgba(34,36,38,.1);
	font-size: 15px;
	font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
	letter-spacing: .3px;

	:last-child {
		border-bottom: none;
	}
`;

const AdminMenu = styled(MenuUL)`
	margin: -3px 35px 0 0;
`;

const SettingsMenu = styled(MenuUL)`
	margin: -3px 110px 0 0;
`;

const CustomDropdown = styled(Dropdown)`
	margin-right: 10px;
`;

function Header({ loading_header, updateLoadingHeader }) {
	const {
		current_organization_id,
		current_project_id,
		updateOrganizationId,
		updateProjectId,
		clearLocalStorage,
		user,
	 } = useContext(HeaderContext);

	const [ showSupport, setShowSupport ]                  = useState(false);
	const [ showSettings, setShowSettings ]                = useState(false);
	const [ organization_options, setOrganizationOptions ] = useState([]);
	const [ project_options, setProjectOptions ]           = useState([]);

	/* eslint-disable */
	useEffect(() => {
		async function foo() {
			updateLoadingHeader(true);

			const organizations = await getAPI(`/organizations`);

			setOrganizationOptions(organizations.data.map(org => {
				return {
					key   : org.id,
					text  : org.title,
					value : org.id,
				}
			}));

			let api_route = `/projects?organization_id=${current_organization_id}`;

			if(!current_organization_id) {
				updateOrganizationId(organizations.data[0].id);
				api_route = `/projects?organization_id=${organizations.data[0].id}`;
			}

			const projects = await getAPI(api_route);

			setProjectOptions(projects.data.map(project => {
				return {
					key   : project.id,
					text  : project.title,
					value : project.id,
				}
			}));

			if(!current_project_id) {
				updateProjectId(projects.data[0].id);
			}

			updateLoadingHeader(false);
		}

		foo();
	}, [current_organization_id]);
	/* eslint-enable */

	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef, { setShowSupport, setShowSettings });

	function handleSupportToggle() {
		setShowSettings(false);
		setShowSupport(!showSupport);
	}

	function handleSettingsToggle() {
		setShowSupport(false);
		setShowSettings(!showSettings);
	}

	function closeMenu() {
		setShowSettings(false);
		setShowSupport(false)
	}

	function handleOrganizationChange(e, { value }) {
		updateOrganizationId(value);

		updateProjectId(null);
	}

	function handleProjectChange(e, { value }) {
		updateProjectId(value);
	}

	function logout() {
		clearLocalStorage();
		window.location = `/login`;
	}

	if(loading_header) {
		return <Loading />
	}

	return (
		<>
			<HeaderContainer>
				<Title>
					<SiteNameLink to="/"><Logo /></SiteNameLink>
				</Title>

				<Right>
					<div>
						{!!user.super_user &&
							<CustomDropdown
								onChange={handleOrganizationChange}
								selection
								options={organization_options}
								value={current_organization_id}
							/>
						}

						<CustomDropdown
							onChange={handleProjectChange}
							selection
							options={project_options}
							value={current_project_id}
						/>

						<TopLink className="menu-nav" ref={wrapperRef} onClick={handleSettingsToggle}>Settings <IconDownArrow name="angle down" /></TopLink>
						<TopLink className="menu-nav" ref={wrapperRef} onClick={handleSupportToggle}>Support <IconDownArrow name="angle down" /></TopLink>
					</div>
				</Right>
			</HeaderContainer>
			{showSettings &&
				<SettingsMenu ref={wrapperRef}>
					{!!user.admin &&
						<MenuLI onClick={closeMenu}><CustomLink to="/admin/users">Administration</CustomLink></MenuLI>
					}
					<MenuLI onClick={closeMenu}><CustomLink to="/profile/info">Profile</CustomLink></MenuLI>
					<MenuLI onClick={closeMenu}><LogoutLink onClick={logout}>Logout</LogoutLink></MenuLI>
				</SettingsMenu>
			}
			{showSupport &&
				<AdminMenu ref={wrapperRef}>
					<MenuLI onClick={closeMenu}>Coming soon</MenuLI>

					{/* <MenuLI onClick={closeMenu}>Documentation</MenuLI>
					<MenuLI onClick={closeMenu}>API Docs</MenuLI>
					<MenuLI onClick={closeMenu}>Videos</MenuLI>
					<MenuLI onClick={closeMenu}>FAQ</MenuLI> */}
				</AdminMenu>
			}
		</>
	);
}

function useOutsideAlerter(ref, { setShowSupport, setShowSettings }) {
	/* eslint-disable */
	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target) && !event.target.classList.contains("menu-nav")) {
				setShowSupport(false);
				setShowSettings(false);
			}
		}

		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref]);
	/* eslint-enable */
}

export default Header;
